import axios, { AxiosRequestConfig } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

export const useSearch = <T extends unknown>(
  url: string,
  axiosCfg: AxiosRequestConfig = {},
  queryOptions: UseQueryOptions<UseSearchResponse<T>, Error> = {}
) => {
  const { queryKey = [], ...restQueryOptions } = queryOptions;
  const getResult = useQuery<UseSearchResponse<T>, Error>({
    queryKey: [url, ...queryKey],

    queryFn: async () => {
      const axiosRes = await axios.request<UseSearchResponse<T>>({ url, method: 'POST', ...axiosCfg });
      return axiosRes.data;
    },

    retry: false,
    ...restQueryOptions,
  });

  return getResult;
};

export type UseSearchResponse<T> = {
  Data: { Rows: T[] };
  Errors: any[] | null;
};
